import { useResetPassword } from "../../api/mutations/user.mutations";
import ResetPasswordForm from "../../component/auth/ResetPasswordForm";

export default function ResetPassword() {
	const { mutate } = useResetPassword();
	return (
		<ResetPasswordForm onSubmit={(data) => mutate(data)} withBackToLogin />
	);
}
